import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["value", "color", "label", "margin", "onChange", "inputRef", "number", "fullWidth", "xs", "md", "checked", "customMargin", "tooltipTitle", "labelPlacement"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState } from 'react';
import { parseAsBool } from '@guryou/utils';
import { Checkbox as MuiCheckBox, FormControlLabel, Tooltip } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import { Block } from '../content';
const CheckBox = props => {
  const {
      value: initialVal,
      color,
      label,
      margin,
      onChange,
      inputRef,
      number,
      fullWidth,
      xs,
      md,
      checked = null,
      customMargin,
      tooltipTitle,
      labelPlacement = 'end'
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [localChecked, setLocalChecked] = useState(checked !== null ? checked : parseAsBool(initialVal));
  const onChangeHandler = event => {
    if (onChange) {
      onChange(event.target.checked);
    }
    setLocalChecked(event.target.checked);
  };
  const inputProps = {
    number
  };
  const checkBox = /*#__PURE__*/React.createElement(MuiCheckBox, _extends({
    color: color || 'primary',
    inputProps: inputProps,
    checked: localChecked,
    value: initialVal,
    onChange: event => onChangeHandler(event)
  }, rest));
  const labelControl = /*#__PURE__*/React.createElement(FormControlLabel, {
    inputRef: inputRef,
    label: label,
    labelPlacement: labelPlacement,
    control: checkBox,
    margin: "normal",
    className: "checkbox ".concat(rest.className),
    style: {
      margin: customMargin ? customMargin : 'normal'
    }
  });
  const content = /*#__PURE__*/React.createElement(FormControl, {
    margin: margin || 'normal',
    fullWidth: fullWidth
  }, tooltipTitle ? /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipTitle
  }, labelControl) : labelControl);
  if (xs || md) {
    let marginProps;
    if (margin === 'normal') {
      marginProps = {
        margin: 4,
        marginBottom: 2
      };
    } else if (margin === 'none') {
      marginProps = {
        margin: 0
      };
    } else {
      marginProps = {
        margin
      };
    }
    return /*#__PURE__*/React.createElement(Block, _extends({
      xs: xs,
      md: md
    }, marginProps), content);
  }
  return content;
};
CheckBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  color: PropTypes.string,
  onClick: PropTypes.func
};
export default CheckBox;